import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '../../../../../../infra/i18n';
import styles from './styles.module.scss';
import tableStyles from '../styles.module.scss';
import UpdateIcon from '../../../icons/campaign-type-update.svg';
import PromotionIcon from '../../../icons/campaign-type-promotion.svg';
import AutomatedIcon from '../../../icons/campaign-type-automated.svg';
import { isAutomatedCampaign, isPromotionCampaign, isUpdateCampaign } from '../../../../campaign-utils';
import { useBreakpoints } from '../../../../../../infra/dls/hooks/use-get-breakpoints';
import { getViewerIdAndKind, useSession } from '../../../../../../infra/session';
import { TextM, TextS } from '../../../../../../infra/dls/components/typography/typography';
export var buildNameAndTypeProps = function (campaign) {
    var result = {
        campaignType: '',
        TypeIcon: function () { return null; },
        campaignName: campaign.displayName,
        campaignId: campaign.id,
    };
    if (isPromotionCampaign(campaign)) {
        result.campaignType = t('engage:filters.promotion');
        result.TypeIcon = PromotionIcon;
    }
    if (isUpdateCampaign(campaign)) {
        result.campaignType = t('engage:filters.quick_update');
        result.TypeIcon = UpdateIcon;
    }
    if (isAutomatedCampaign(campaign)) {
        result.campaignType = t('engage:filters.automated');
        result.TypeIcon = AutomatedIcon;
    }
    return result;
};
export var NameAndType = function (_a) {
    var campaignType = _a.campaignType, TypeIcon = _a.TypeIcon, campaignName = _a.campaignName, campaignId = _a.campaignId;
    var session = useSession().data;
    var kind = getViewerIdAndKind(session).kind;
    var isTabletOrSmaller = useBreakpoints().isTabletOrSmaller;
    var shouldTruncateTitle = isTabletOrSmaller && kind === 'shop';
    return (_jsxs("div", { className: styles.multiline, children: [_jsx(TextM, { as: "span", color: "primary", id: "campaign-name-".concat(campaignName), className: "".concat(styles.header, " ").concat(styles.fullwidth, " ").concat(tableStyles['campaign-name'], " ").concat(shouldTruncateTitle ? styles.truncate : ''), automationId: "text:campaignName:".concat(campaignId), children: campaignName }), _jsxs("div", { className: "u-flex u-align-items-center ".concat(styles.subheader), children: [_jsx(TypeIcon, {}), _jsx(TextS, { as: "span", className: "u-ml--", automationId: "text:campaignType:".concat(campaignType), children: campaignType })] })] }));
};
